import PropTypes from 'prop-types'
import React, { Component } from 'react'
import styles from './badges-group.styl'
import { get } from 'lodash'
import { FormattedMessage } from 'react-intl'

class BadgeGroup extends Component {
  static propTypes = {
    badges: PropTypes.object.isRequired,
    awardBadges: PropTypes.object.isRequired,
    badgesProgress: PropTypes.object.isRequired,
    award: PropTypes.object.isRequired,
    activity: PropTypes.object.isRequired,
    badge: PropTypes.object.isRequired,
    isBadgesStrictModeEnabled: PropTypes.object.isRequired
  }

  getBadgeIconImg = (awardBadges, badge, award) => {
    const awardLvl = get(award, 'awardLevel.value')

    const imgMap = get(badge, 'organizationBadgeConfiguration.imageMap')

    const isObtained = awardBadges.filter(awardBadge => get(awardBadge, 'badge.id') === get(badge, 'id')).length > 0

    if (imgMap && imgMap[awardLvl]) {
      return isObtained ? imgMap[awardLvl].active : imgMap[awardLvl].inactive
    }
    return ''
  }

  getPredictionForFinishBadge = (badge, badgesProgressBySection) => {
    const badgeLvl = get(badge, 'badgeLevel.value')

    return badgesProgressBySection && badgesProgressBySection[badgeLvl] && get(badgesProgressBySection[badgeLvl], 'weeksToFinish') || 0
  }

  getBadgeDescription = (badge, badgesProgressBySection) => {
    const badgeLvl = get(badge, 'badgeLevel.value')

    return badgesProgressBySection && badgesProgressBySection[badgeLvl] && get(badgesProgressBySection[badgeLvl], 'description') || ''
  }

  render() {
    const { badges, awardBadges, badgesProgress, award, activity, badge } = this.props

    const badgeName = get(badge, 'name.value')

    const badgesData = get(badges, 'badges') && get(badges, 'badges')[badgeName]

    const badgeByName =  get(badgesData, 'badges')

    const activitySection = get(activity, 'activitySection.value')

    const badgesProgressBySection = badgesProgress && get(badgesProgress, 'progressValues')[activitySection]

    const filteredAwardBadges = awardBadges.filter(ab => get(ab, 'activitySection.value') === activitySection)

    const groupDesc = badgeByName && badgeByName.length > 0 && get(badgeByName[0], 'badgeGroup.description')


    return (
      <div className={styles.badgeGroupWrapper}>
       <div className={styles.groupDescription}>
        <p>{groupDesc}</p>
       </div>

        <div className={styles.badgeGroupBadgesWrapper}>
        { badgeByName && badgeByName.map(badge => {
          const badgeIconImg = this.getBadgeIconImg(filteredAwardBadges, badge, award)

          const weeksToAchieve = this.getPredictionForFinishBadge(badge, badgesProgressBySection)

          const badgeDescription = this.getBadgeDescription(badge, badgesProgressBySection)

          const isBadgeObtained = weeksToAchieve > 0

          return(
              <div className={ isBadgeObtained ? styles.badgeProgress : styles.withoutBadgeProgress}>
                {weeksToAchieve > 0 && <div className={styles.title}>
                  <FormattedMessage
                      id="label.badge_to_achieve_count"
                      defaultMessage="{weeksToAchieve} weeks to"
                      values={{
                        weeksToAchieve: weeksToAchieve
                      }}
                  />
                </div>}
                <div className={styles.badgeWrapper}>
                  <div className={ isBadgeObtained ? styles.badgeIcon : styles.nonactiveBadgeIcon} >
                    <img src={`data:image/png;base64, ${badgeIconImg}`} />
                  </div>
                  <div className={styles.badgeDescriptionWrapper}>
                    <h4>{get(badge, 'badgeLevel.translationText')}</h4>
                    <div className={styles.badgeDescription}>
                      <span>
                        {badgeDescription}
                      </span>
                    </div>
                  </div>
                </div>
                <div className={styles.clear}></div>

              </div>
          )
        })}
        </div>
      </div>
    )
  }
}

export default BadgeGroup
